export default {
  edit_profile: "Edit profile",
  my_account: "My account",
  balance: "Balance",
  available_for_withdrawal: "Available for withdrawal",
  amount_in_hold: "Amount on Hold",
  latest_news: "Latest news",
  more_news: "More news"
};
